import React, { Component } from 'react';
import classNames from 'classnames';
import {
	SortableContainer,
	SortableElement,
	SortableHandle
} from 'react-sortable-hoc';
// import Icon from '../../common/components/Icon';
import Icon from '../Icon';

const LockingsList = SortableContainer(({ lockings = [], ...props }) => (
	<div className="lockings-list">
		{lockings.map((locking, index) => {
			return (
				<LockingFactory
					{...props}
					key={locking.locking_id}
					index={index}
					locking={locking}
				/>
			);
		})}
	</div>
));

const DragHandle = SortableHandle(() => <Icon icon="arrows-y" />);

const LockingFactory = SortableElement(({ locking, ...props }) => {
	const {
		isActive = locking => null,
		activeClass,
		dragIndicator,
		parent,
		onItemClick,
		onToggleGroup
	} = props;

	const isGroup = locking.is_locking === false;

	const classes = classNames('locking', {
		'locking--group': isGroup
	});

	const itemClasses = classNames('locking__item', {
		'locking__item--group': isGroup,
		[activeClass]: isActive(locking)
	});

	return (
		<div className={classes}>
			<div className={itemClasses}>
				<div className="locking__drag">
					{dragIndicator && <DragHandle />}
				</div>

				<div
					className="locking__name"
					onClick={() => onItemClick(locking, parent)}
				>
					{/* Render Folder icon */}
					{isGroup && (
						<div className="locking__folder">
							<Icon icon="folder" />
						</div>
					)}

					{locking.name}
				</div>

				{/* Render toggle */}
				{isGroup && (
					<div className="locking__arrow" onClick={onToggleGroup}>
						<Icon icon="arrow-top" />
					</div>
				)}
			</div>

			{/* Render children */}
			{isGroup && (
				<div className="locking__children">
					{locking.children.map((childLocking, index) => (
						<LockingFactory
							{...props}
							key={childLocking.locking_id}
							index={index}
							collection={locking.locking_id}
							locking={childLocking}
							parent={locking}
						/>
					))}
				</div>
			)}
		</div>
	);
});

const withSortableProps = ({ sortable, onSortEnd, ...props }) => {
	const sortableContainerProps = {
		axis: 'y',
		lockAxis: 'y',
		useDragHandle: true,
		shouldCancelStart: () => !sortable,
		onSortEnd
	};

	return (
		<LockingsList
			{...props}
			{...sortableContainerProps}
			dragIndicator={sortable}
		/>
	);
};

export default withSortableProps;



// WEBPACK FOOTER //
// ./src/js/common/components/LockingsList/LockingsList.js